import { API_USER_TABLE_SETTINGS, API_USER_TABLE_SETTINGS_SYNC } from '../constants/api.js'
import axios from 'axios'

// Безопасное чтение объекта из localStorage: повреждённое значение не должно ломать приложение
function readStoredObject(key) {
    try {
        const value = JSON.parse(localStorage.getItem(key))
        return value && typeof value === 'object' ? value : {}
    } catch (e) {
        return {}
    }
}

const state = {
    filterSettings: {
        companyTable: localStorage.getItem('filterSettings.companyTable') || 1,
        orderTable: localStorage.getItem('filterSettings.orderTable') || '3,0',
        orderServiceTable: localStorage.getItem('filterSettings.orderServiceTable') || 1,
        orderServiceLogisticTable: localStorage.getItem('filterSettings.orderServiceLogisticTable') || 2,
        financeTable: localStorage.getItem('filterSettings.financeTable') || 2,
        financeRequestsTable: localStorage.getItem('filterSettings.financeRequestsTable') || 4,
        agentCompaniesTable: localStorage.getItem('filterSettings.agentCompaniesTable') || 0
    },
    filterHeaderSettings: {
        orderTable: JSON.parse(localStorage.getItem('filterHeaderSettings.orderTable')) || {"sales_manager_id":[],"reference_order_status_id":[],"outsourcing_order":"","reference_sources_id":[]},
        orderServiceLogisticTable: JSON.parse(localStorage.getItem('filterHeaderSettings.orderServiceLogisticTable')) || {"teo_manager_id":[],"reference_property_type_id":[],"reference_property_status_id":[]},
        // Отчёт «Финансовые показатели заказов»: применённые фильтры, сортировка, размер страницы
        orderFinanceReport: readStoredObject('filterHeaderSettings.orderFinanceReport'),
    },
    tableHeaderSettings: {
        companyTable: {},
        orderTable: {},
        orderServiceLogisticTable: {},
        financeTable: {},
        financeRequestsTable: {},
        agentCompaniesTable: {},
        orderServiceTable_22: {},
        orderServiceTable_23: {},
        orderServiceTable_24: {},
        orderServiceTable_25: {},
        orderServiceTable_75: {},
        orderServiceTable_76: {},
        orderServiceTable_77: {},
        orderFinanceReport: {},
    },
    interfaceSettings: {
        sidebarMenu: localStorage.getItem('interfaceSettings.sidebarMenu') || '',
    },
    // Флаг для отслеживания синхронизации с БД
    isDbSyncEnabled: true,
    // Кэш настроек из БД
    dbTableHeaderSettings: {}
}
const mutations = {
    SET_FILTER_SETTINGS : (state, payload) => {
        let setting = payload
        localStorage.setItem('filterSettings.' + setting.name, setting.value)
        state.filterSettings[setting.name] = setting.value
    },
    SET_FILTER_HEADER_SETTINGS : (state, payload) => {
        let setting = payload

        Object.assign(state.filterHeaderSettings[setting.name], setting.value)

        localStorage.setItem('filterHeaderSettings.' + setting.name, JSON.stringify(state.filterHeaderSettings[setting.name]))
    },
    SET_TABLE_HEADER_SETTINGS : (state, payload) => {
        let setting = payload

        Object.assign(state.tableHeaderSettings[setting.name], setting.value)

        localStorage.setItem('tableHeaderSettings.' + setting.name, JSON.stringify(state.tableHeaderSettings[setting.name]))
    },
    // Новые мутации для работы с БД
    SET_DB_TABLE_HEADER_SETTINGS : (state, payload) => {
        state.dbTableHeaderSettings = payload
    },
    UPDATE_DB_TABLE_HEADER_SETTING : (state, payload) => {
        state.dbTableHeaderSettings[payload.tableName] = payload.settings
    },
    SET_DB_SYNC_ENABLED : (state, enabled) => {
        state.isDbSyncEnabled = enabled
    },
    SET_INTERFACE_SETTINGS : (state, payload) => {
        let setting = payload
        localStorage.setItem('interfaceSettings.' + setting.name, setting.value)
        state.interfaceSettings[setting.name] = setting.value
    }
}
const getters = {
    FILTER_SETTINGS : state => {
        return state.filterSettings
    },
    FILTER_HEADER_SETTINGS : state => {
        return state.filterHeaderSettings
    },
    TABLE_HEADER_SETTINGS : state => {
        return state.tableHeaderSettings
    },
    INTERFACE_SETTINGS : state => {
        return state.interfaceSettings
    },
    // Новые геттеры для работы с БД
    DB_TABLE_HEADER_SETTINGS : state => {
        return state.dbTableHeaderSettings
    },
    IS_DB_SYNC_ENABLED : state => {
        return state.isDbSyncEnabled
    }
}
const actions = {
    SET_FILTER_SETTINGS : (context, payload) => {
        context.commit('SET_FILTER_SETTINGS', payload)
    },
    SET_FILTER_HEADER_SETTINGS : (context, payload) => {
        context.commit('SET_FILTER_HEADER_SETTINGS', payload)
    },
    SET_TABLE_HEADER_SETTINGS : (context, payload) => {
        context.commit('SET_TABLE_HEADER_SETTINGS', payload)
    },
    SET_INTERFACE_SETTINGS : (context, payload) => {
        context.commit('SET_INTERFACE_SETTINGS', payload)
    },
    // Новые действия для работы с БД
    async LOAD_TABLE_HEADER_SETTINGS_FROM_DB(context, tableName) {
        try {
            const response = await axios.get(`${API_USER_TABLE_SETTINGS}/${tableName}`)
            if (response.data.success && response.data.settings) {
                context.commit('UPDATE_DB_TABLE_HEADER_SETTING', {
                    tableName: tableName,
                    settings: response.data.settings
                })
                return response.data.settings
            }
            return null
        } catch (error) {
            return null
        }
    },
    async SAVE_TABLE_HEADER_SETTINGS_TO_DB(context, { tableName, settings }) {
        try {
            const response = await axios.post(`${API_USER_TABLE_SETTINGS}/${tableName}`, {
                settings: settings
            })
            if (response.data.success) {
                context.commit('UPDATE_DB_TABLE_HEADER_SETTING', {
                    tableName: tableName,
                    settings: settings
                })
            }
            return response.data.success
        } catch (error) {
            return false
        }
    },
    async SYNC_ALL_SETTINGS_TO_DB(context) {
        try {
            const response = await axios.post(API_USER_TABLE_SETTINGS_SYNC, {
                tableHeaderSettings: context.state.tableHeaderSettings
            })
            if (response.data.success) {
                context.commit('SET_DB_TABLE_HEADER_SETTINGS', context.state.tableHeaderSettings)
            }
            return response.data.success
        } catch (error) {
            console.error('Ошибка синхронизации с БД:', error)
            return false
        }
    },
    async LOAD_ALL_SETTINGS_FROM_DB(context) {
        try {
            const response = await axios.get(API_USER_TABLE_SETTINGS)
            if (response.data.success && response.data.settings) {
                context.commit('SET_DB_TABLE_HEADER_SETTINGS', response.data.settings)
                return response.data.settings
            }
            return null
        } catch (error) {
            console.error('Ошибка загрузки всех настроек из БД:', error)
            return null
        }
    },
    // Умное получение настроек таблицы (с приоритетом: localStorage -> БД -> стандартные)
    async GET_TABLE_HEADER_SETTINGS(context, tableName) {
        // 1. Проверяем localStorage
        const localSettings = context.state.tableHeaderSettings[tableName]
        if (localSettings && Object.keys(localSettings).length > 0) {
            return localSettings
        }
        
        // 2. Проверяем кэш БД
        const dbSettings = context.state.dbTableHeaderSettings[tableName]
        if (dbSettings && Object.keys(dbSettings).length > 0) {
            // Обновляем localStorage и store
            context.commit('SET_TABLE_HEADER_SETTINGS', {
                name: tableName,
                value: dbSettings
            })
            return dbSettings
        }
        
        // 3. Загружаем из БД
        const settingsFromDb = await context.dispatch('LOAD_TABLE_HEADER_SETTINGS_FROM_DB', tableName)
        if (settingsFromDb && Object.keys(settingsFromDb).length > 0) {
            // Обновляем localStorage и store
            context.commit('SET_TABLE_HEADER_SETTINGS', {
                name: tableName,
                value: settingsFromDb
            })
            return settingsFromDb
        }
        
        // 4. Возвращаем стандартные настройки (пустой объект)
        return {}
    },
    // Умное сохранение настроек таблицы (в localStorage, store и БД)
    async SET_TABLE_HEADER_SETTINGS_SMART(context, { tableName, settings }) {
        // Сохраняем в localStorage и store
        context.commit('SET_TABLE_HEADER_SETTINGS', {
            name: tableName,
            value: settings
        })
        
        // Сохраняем в БД (если включена синхронизация)
        if (context.state.isDbSyncEnabled) {
            await context.dispatch('SAVE_TABLE_HEADER_SETTINGS_TO_DB', {
                tableName: tableName,
                settings: settings
            })
        }
    },
    // Инициализация и синхронизация при загрузке приложения
    async INITIALIZE_AND_SYNC(context) {
        try {
            
            // 1. Сначала загружаем все настройки из БД
            const dbSettings = await context.dispatch('LOAD_ALL_SETTINGS_FROM_DB')
            
            // 2. Если в БД есть настройки - загружаем их
            if (dbSettings && Object.keys(dbSettings).length > 0) {
                // Обновляем localStorage и store настройками из БД
                for (const [tableName, settings] of Object.entries(dbSettings)) {
                    if (settings && Object.keys(settings).length > 0) {
                        context.commit('SET_TABLE_HEADER_SETTINGS', {
                            name: tableName,
                            value: settings
                        })
                    }
                }
            } else {
                // Если в БД нет настроек, загружаем из localStorage (если есть)
                const tableNames = ['companyTable', 'orderTable', 'orderServiceLogisticTable', 'financeTable', 'financeRequestsTable', 'agentCompaniesTable', 'orderServiceTable_22', 'orderServiceTable_23', 'orderServiceTable_24', 'orderServiceTable_25', 'orderServiceTable_75', 'orderServiceTable_76', 'orderServiceTable_77', 'orderFinanceReport']
                
                for (const tableName of tableNames) {
                    const localSettings = localStorage.getItem(`tableHeaderSettings.${tableName}`)
                    if (localSettings) {
                        try {
                            const parsedSettings = JSON.parse(localSettings)
                            if (parsedSettings && Object.keys(parsedSettings).length > 0) {
                                context.commit('SET_TABLE_HEADER_SETTINGS', {
                                    name: tableName,
                                    value: parsedSettings
                                })
                            }
                        } catch (error) {
                            // Игнорируем ошибки парсинга
                        }
                    }
                }
            }
            
            return true
        } catch (error) {
            return false
        }
    },
    // Сохранение конкретных настроек из localStorage в БД
    async SAVE_LOCAL_SETTINGS_TO_DB(context, settingsToSync) {
        try {
            for (const [tableName, settings] of Object.entries(settingsToSync)) {
                await context.dispatch('SAVE_TABLE_HEADER_SETTINGS_TO_DB', {
                    tableName: tableName,
                    settings: settings
                })
            }
            return true
        } catch (error) {
            return false
        }
    },
    // Сброс всех настроек пользователя при логауте
    RESET_USER_SETTINGS(context) {
        
        // Сбрасываем состояние к начальным значениям
        context.commit('SET_DB_TABLE_HEADER_SETTINGS', {})
        context.commit('SET_DB_SYNC_ENABLED', true)
        
        // Сбрасываем настройки таблиц к пустым объектам в основном состоянии
        const emptyTableSettings = {}
        Object.keys(context.state.tableHeaderSettings).forEach(tableName => {
            emptyTableSettings[tableName] = {}
            // Сбрасываем каждую таблицу в основном состоянии
            context.commit('SET_TABLE_HEADER_SETTINGS', {
                name: tableName,
                value: {}
            })
        })
        
    }
}

export default {
    namespaced: true,
    state, getters, mutations, actions
}
